module.exports = __webpack_public_path__ + "img/73ne.a65a8f49.svg";